const STORAGE_KEY = 'amc_geolocation';
const GEO_API = 'https://gw.cds.amcn.com/geolocation-id/api/v1/geolocation';

function applyGeolocation( geo ) {
	if ( geo === 'ca' ) {
		document.querySelectorAll( '.ca-accessibility' ).forEach( function( el ) {
			el.classList.remove( 'hide' );
		} );
	}
}

export function geolocationInit() {
	const stored = sessionStorage.getItem( STORAGE_KEY );

	if ( stored !== null ) {
		applyGeolocation( stored );
		return;
	}

	fetch( GEO_API )
		.then( function( response ) { return response.json(); } )
		.then( function( data ) {
			const geo = data?.data?.geolocation ?? '';
			sessionStorage.setItem( STORAGE_KEY, geo );
			applyGeolocation( geo );
		} )
		.catch( function() {
			sessionStorage.setItem( STORAGE_KEY, '' );
		} );
}
